module.exports = __webpack_public_path__ + "img/symbol_5.3e452ed8.png";